import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const GET_ITEM_QUERY = print(gql`
  query FormResponse($id: Int!) {
    FormResponse(id: $id) {
      id
      status
      internalInfo
    }
  }
`);

export interface GetItemGql {
  FormResponse: {
    id: number;
    status?: string;
    internalInfo?: string;
    // formSlug: string;
    // response: string;
    // userId: string;
    // createdAt: string;
    // updatedAt: string;
  };
}
